import { render } from "./kemaskiniPengecualian.vue?vue&type=template&id=5fcf351b"
import script from "./kemaskiniPengecualian.vue?vue&type=script&lang=js"
export * from "./kemaskiniPengecualian.vue?vue&type=script&lang=js"

import "./kemaskiniPengecualian.vue?vue&type=style&index=0&id=5fcf351b&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__